import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LinkButton from "@components/Buttons/LinkButton/LinkButton";
import Widget from "@components/Widget/Widget";
import WindyIcon from "@features/Weather/components/WindyIcon";
import YrIcon from "@features/Weather/components/YrIcon";
import "./WeatherLinkWidget.scss";
import { useIataContext } from "@contexts/IataContext";
const iataToIcaoMap = {
    OSL: "ENGM",
    BGO: "ENBR",
    TRD: "ENVA",
    SVG: "ENZV",
};
const iataToYrUrlMap = {
    OSL: "https://www.yr.no/nb/detaljer/graf/1-86450/Norge/Akershus/Ullensaker/Oslo%20lufthavn,%20Gardermoen",
    BGO: "https://www.yr.no/nb/detaljer/graf/1-92871/Norge/Vestland/Bergen/Bergen%20lufthavn,%20Flesland",
    TRD: "https://www.yr.no/nb/detaljer/graf/1-212209/Norge/Tr%C3%B8ndelag/Stj%C3%B8rdal/Trondheim%20lufthavn,%20V%C3%A6rnes",
    SVG: "https://www.yr.no/nb/detaljer/graf/1-15399/Norge/Rogaland/Sola/Stavanger%20lufthavn,%20Sola",
};
export const WeatherLinkWidget = () => {
    var _a;
    const { iata } = useIataContext();
    const icao = iataToIcaoMap[iata];
    const windyUrl = icao ? `https://www.windy.com/airport/${icao}` : "https://www.windy.com/";
    const yrUrl = (_a = iataToYrUrlMap[iata]) !== null && _a !== void 0 ? _a : "https://www.yr.no/";
    return (_jsx(Widget.Container, { children: _jsx(Widget.Body, { children: _jsx("div", { className: "weather-link-container", children: _jsxs("div", { className: "weather-link-widget", children: [_jsxs(LinkButton, { title: "windy", url: windyUrl, variant: "secondary", children: [_jsx(WindyIcon, {}), "Windy"] }), _jsxs(LinkButton, { title: "yr", url: yrUrl, variant: "secondary", children: [_jsx(YrIcon, {}), "Yr"] })] }) }) }) }));
};
WeatherLinkWidget.displayName = "WeatherLinkWidget";
